/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Avatar_TitleInputs */



/**
* | output |
* | --- |
* | "Update Avatar" |
*
* @param {Avatar_TitleInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const avatar_title = /** @type {((inputs?: Avatar_TitleInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Avatar_TitleInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Mettre à jour l'avatar")
	if (locale === "es") return /** @type {LocalizedString} */ ("Actualizar avatar")
	if (locale === "pt") return /** @type {LocalizedString} */ ("Atualizar Avatar")
	if (locale === "it") return /** @type {LocalizedString} */ ("Aggiorna Avatar")
	return /** @type {LocalizedString} */ ("Update Avatar")
});